import {
    createLazyComponent,
    LazyImport,
    LazyModule,
    registerLazyOrchestrator,
} from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { onSearchSessionStarted, getSuggestions } from 'owa-search-next-lazy';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailSearchNextLazy", webpackPrefetch: true */ './lazyIndex')
);

const lazySuggestionsModule = new LazyModule(() =>
    import(/* webpackChunkName: "LazySuggestions", webpackPrefetch: true */ './lazySuggestions')
);

// Init
export const lazyInitializeMailSearch = new LazyImport(lazyModule, m => m.initializeMailSearch);
export function initializeMailSearch() {
    if (isFeatureEnabled('sea-lazy2')) {
        lazyInitializeMailSearch.import().then(initializeMailSearch => initializeMailSearch());
        lazyGetMailSearchNextStore.import();
        lazyGetSearchProvider.import();
    }
}

// Actions
export { default as clearSearchScope } from './actions/clearSearchScope';
export { default as onFindEmailFromSenderClicked } from './actions/onFindEmailFromSenderClicked';
export {
    default as loadMessageSuggestionIntoTable,
} from './actions/loadMessageSuggestionIntoTable';
export {
    default as loadTableViewFromSearchTableQuery,
    LoadTableViewFromSearchTableQueryActionMessage,
} from './actions/loadTableViewFromSearchTableQuery';
export { default as removeSearchTableFromStore } from './actions/removeSearchTableFromStore';
export { default as selectPreviousNode } from './actions/selectPreviousNode';
export { default as setStaticSearchScope } from './actions/setStaticSearchScope';
export { default as startSearchWithCategory } from './actions/startSearchWithCategory';
export { default as onAnswerReceived } from './actions/onAnswerReceived';

// Store
export const lazyGetMailSearchNextStore = new LazyImport(lazyModule, m => m.getMailSearchNextStore);

// Types
export { default as SearchProvider } from './types/SearchProvider';

// Utils
export const lazyGetSearchProvider = new LazyImport(lazyModule, m => m.getSearchProvider);
export let lazyCreateFallbackPersonaSearchTableQuery = new LazyImport(
    lazyModule,
    m => m.createFallbackPersonaSearchTableQuery
);
export let lazyCreateFallbackPrivateDistributionListSearchTableQuery = new LazyImport(
    lazyModule,
    m => m.createFallbackPrivateDistributionListSearchTableQuery
);
export let lazyCreateFallbackCategorySearchTableQuery = new LazyImport(
    lazyModule,
    m => m.createFallbackCategorySearchTableQuery
);

// Components
export const AnswersContainer = createLazyComponent(lazyModule, m => m.AnswersContainer);
export const SearchHeaderFirstRowContent = createLazyComponent(
    lazyModule,
    m => m.SearchHeaderFirstRowContent
);
export const SearchRefiners = createLazyComponent(lazyModule, m => m.SearchRefiners);
export const FolderScope = createLazyComponent(lazyModule, m => m.FolderScope);

// Lazy orchestrators
registerLazyOrchestrator(
    onSearchSessionStarted,
    lazyModule,
    m => m.onSearchSessionStartedOrchestrator
);

registerLazyOrchestrator(getSuggestions, lazySuggestionsModule, m => m.getSuggestionsOrchestrator);

// Services
export const lazyGetAnswerService = new LazyImport(lazyModule, m => m.getAnswerService);
